module.exports = __webpack_public_path__ + "img/mobile-woman.d820959b.png";